exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1_ScZdvlCAx5x3TD2Il6qZ{color:\"[theme:themePrimary, default:#0078D7]\"}html[dir=ltr] ._1_ScZdvlCAx5x3TD2Il6qZ{padding-left:0}html[dir=rtl] ._1_ScZdvlCAx5x3TD2Il6qZ{padding-right:0}._1dgcRHyL_EWZ52cNOgSy4c{font-size:12px}html[dir] ._1dgcRHyL_EWZ52cNOgSy4c{margin-top:2px}html[dir=ltr] ._1dgcRHyL_EWZ52cNOgSy4c{margin-left:0}html[dir=rtl] ._1dgcRHyL_EWZ52cNOgSy4c{margin-right:0}", ""]);

// exports
exports.locals = {
	"createCategoryButton": "_1_ScZdvlCAx5x3TD2Il6qZ",
	"icon": "_1dgcRHyL_EWZ52cNOgSy4c"
};